import { useLocation, useMatch } from "react-router-dom";
import data from '../utils/data.json';

export const useLinkDestination = () => {

  const location = useLocation();
  const match = useMatch('/galleria/:servizioId');
  const servizioId = match?.params?.servizioId ?? null;
  const selectedService = data?.galleria?.ita?.find(servizio => servizio?.id === servizioId)?.id;
  const onGallery = location.pathname.startsWith('/galleria');

  return (link) => {
    if (onGallery) {
      return selectedService ? `/galleria/${selectedService}` : '/galleria';
    }
    return link?.id === 4 ? '/galleria' : '/';
  };
};
